export default {
  "category.shoes": "Chaussures",
  "category.hoodies": "Sweats / Pulls",
  "category.tshirts": "T-shirts",
  "category.jackets": "Vestes",
  "category.pants": "Pantalons / Shorts",
  "category.headwear": "Couvre-chefs",
  "category.sets": "Ensembles",
  "category.underwear": "Sous-vêtements",
  "category.jersey": "Maillot",
  "category.accessories": "Accessoires",
  "category.bags": "Sacs",
  "category.belts": "Ceintures",
  "category.perfumes": "Parfums",
  "category.other": "Autres articles",
};